import { useAuth } from 'features/auth';
import { useSchool } from 'features/school';
import { useEffect } from 'react';

const ChatBot = () => {
  const { schoolAlias } = useSchool();
  const { loginEmail } = useAuth();

  useEffect(() => {
    if (schoolAlias === 'b3') {
      const script = document.createElement('script');
      script.type = 'module';
      script.crossOrigin = 'anonymous';
      script.async = true;
      script.src = 'https://azrstddswidhbfappindevn.azureedge.net/assets/index-3c5e540b.js';

      document.body.appendChild(script);

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://azrstddswidhbfappinp.azureedge.net/assets/index-efad860c.css';
      document.body.appendChild(link);
    }
  });

  return loginEmail === 'felipe@melver.com.br' || loginEmail === 'bruno.bernardo@melver.com.br' || loginEmail === 'taina.pereira@b3.com.br' ? (
    <div id="educa-chat-gpt" data-custom-id={loginEmail}></div>
  ) : (
    <></>
  );
};

export default ChatBot;
